import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { RootState } from '../../../configs/store';

function SportsBettingTitle() {
  const { filterSports: { tournaments, type } } = useSelector((state: RootState) => state.events);
  const { t } = useTranslation('common');

  const checkTitle = () => {
    if (type === '2,8'){
      return 'liveNow';
    }
    return tournaments.length === 0 ? 'topEvents' : 'prematch';
  };

  return (
    <div className="sports-betting__title-container">
      {
        <span className="sports-betting__title">
          { t(`sports.${ checkTitle() }`) }
        </span>
      }
    </div>
  );
}

export default SportsBettingTitle;
